import type { ReactNode } from 'react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '~/lib/queries/session';

// Middle tier of the three-tier route-protection model. See
// docs/ADHERENCE.md § Authentication for the full pattern.
//
//   - Public pages               → top-level routes (no layout guard)
//   - Auth-only pages            → routes under `_authed/`   (THIS FILE)
//   - Auth + subscription pages  → routes under `_protected/`
//
// This layout enforces a signed-in session only (gated server-side in
// `beforeLoad`). Pages that also need an organization or an active subscription
// live under `_protected/` instead.
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());
    if (!session) {
      throw redirect({ to: '/sign-in' });
    }
    return { session };
  },
  component: AuthedLayout,
});

function AuthedLayout(): ReactNode {
  // Auth is resolved + gated in `beforeLoad`; this layout just frames its children.
  return <Outlet />;
}
